import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-public_arrow_left",
  "use": "icon-public_arrow_left-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-public_arrow_left\"><clipPath id=\"icon-public_arrow_left_a\"><path d=\"m0 0h24v24h-24z\" /></clipPath><g clip-path=\"url(#icon-public_arrow_left_a)\"><path d=\"m15.8 21.1c-.3 0-.5-.1-.7-.3l-7.7-7.7c-.2-.3-.4-.6-.4-1s.2-.8.4-1.1l7.7-7.7c.4-.4 1-.4 1.4 0s.4 1 0 1.4l-7.3 7.3 7.3 7.3c.4.4.4 1 0 1.4-.1.3-.4.4-.7.4z\" fill=\"#666\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/public_arrow_left.svg
// module id = leiL
// module chunks = 87